import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import {
  CreateSharedRecordingDto,
  PublicSharedRecording,
} from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const shareRecording = async ({
  orgId,
  data,
}: {
  orgId: string;
  data: CreateSharedRecordingDto;
}): Promise<PublicSharedRecording> => {
  const response = await axiosClient.post(`/${orgId}/shared-recordings`, data);
  return response.data;
};

function useShareRecording(
  mutationOptions?: Partial<
    UseMutationOptions<
      PublicSharedRecording,
      HttpError,
      { orgId: string; data: CreateSharedRecordingDto }
    >
  >,
) {
  return useMutation({
    mutationFn: ({ orgId, data }) => shareRecording({ orgId, data }),
    ...mutationOptions,
  });
}
export { useShareRecording };
